import React, { useState } from 'react'
import "./UserFbPages.css"
import SponsorIcon from "../../../assets/icons/sponsor.svg"
import { useDispatch } from 'react-redux';
import { fbActions } from '../../../store/fb-slice';

const UserFbPages = (props) => {
  const {allPages} = props;
  const dispatch=useDispatch();
  const [selectedFbPage,setSelectedFbPage]=useState();
  function closeModal(){
    props.closeModal();
  }
  
  function handleSelectedFbPage(id){
    const selected=allPages.find(allId=>allId.id===id);
    setSelectedFbPage(selected);
  }
  function handleSelectedFbPageDone(){
    dispatch(fbActions.setSelectedFbPage(selectedFbPage));
    props.closeModal();
  }



  return (
    <div className="modalBg">
      <div class="modal" tabindex="-1">
        <div class="modal-dialog modal-fbPageDialog">
          <div class="modal-content">
            <div className="modalClose">
              <img className='categoryModalClose' src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/close-circle.svg" alt="close-modal-img" onClick={closeModal} />
            </div>
            <div className="modal-main">
              <div className="modalHeading">
                <h6 className='modal-heading'>Your Facebook Pages</h6>
                <p className='modal-subHeading'>Select your facebook page</p>
                <hr className='stepsHr' />
              </div>
              <div className="linkedFbPageInfo">
                {allPages.map(data=>{
                  return (
                    <div className='linkedFbPagesInfo'>
                      <span className='linkedFbPage-info'>
                          <img className='linkedFbPage-img' src={data.picture.data.url} alt="linked-fb-page-img" />
                          <span className='linkedFbpage-details'>
                              <p className='linkedFbPage-name'>{data.name}</p>
                              <p className='linkedFbPage-sponsor'>Sponsored <img className='linkedFbPage-sponsor-icon' src={SponsorIcon} alt="sponsor-img" /></p>
                          </span>
                      </span>
                      <button className='linkedFbPage-switch' onClick={e=>handleSelectedFbPage(data.id)}>{selectedFbPage?.id===data?.id ? 'Selected' : 'Select'}</button>
                    </div>
                  )
                })}
              </div>
              <div className="fbPagesModalBtn">
                <button className='categoryModalDoneBtn' onClick={handleSelectedFbPageDone}>Done</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserFbPages